// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-input {
  display: grid;
  flex: 1 1 auto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
:where(.vuetify-styles) .v-input--disabled {
  pointer-events: none;
}
:where(.vuetify-styles) .v-input--density-default {
  --v-input-control-height: 56px;
  --v-input-padding-top: 16px;
}

:where(.vuetify-styles) .v-input--density-comfortable {
  --v-input-control-height: 48px;
  --v-input-padding-top: 12px;
}

:where(.vuetify-styles) .v-input--density-compact {
  --v-input-control-height: 40px;
  --v-input-padding-top: 8px;
}

:where(.vuetify-styles) .v-input--vertical {
  grid-template-areas: "append" "control" "prepend";
  grid-template-rows: max-content auto max-content;
  grid-template-columns: min-content;
}
:where(.vuetify-styles) .v-input--vertical .v-input__prepend {
  margin-block-start: 16px;
}
:where(.vuetify-styles) .v-input--vertical .v-input__append {
  margin-block-end: 16px;
}

:where(.vuetify-styles) .v-input--horizontal {
  grid-template-areas: "prepend control append" "a messages b";
  grid-template-columns: max-content minmax(0, 1fr) max-content;
  grid-template-rows: 1fr auto;
}
:where(.vuetify-styles) .v-input--horizontal .v-input__prepend {
  margin-inline-end: 16px;
}
:where(.vuetify-styles) .v-input--horizontal .v-input__append {
  margin-inline-start: 16px;
}

:where(.vuetify-styles) .v-input__details {
  align-items: flex-end;
  display: flex;
  font-size: 0.75rem;
  font-weight: 400;
  grid-area: messages;
  letter-spacing: 0.0333333333em;
  line-height: normal;
  min-height: 22px;
  padding-top: 6px;
  overflow: hidden;
  justify-content: space-between;
}

:where(.vuetify-styles) .v-input__details > .v-icon,
:where(.vuetify-styles) .v-input__prepend > .v-icon,
:where(.vuetify-styles) .v-input__append > .v-icon {
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-input--disabled .v-input__details > .v-icon,
:where(.vuetify-styles) .v-input--disabled .v-input__details .v-messages,
:where(.vuetify-styles) .v-input--error .v-input__details > .v-icon,
:where(.vuetify-styles) .v-input--error .v-input__details .v-messages,
:where(.vuetify-styles) .v-input--disabled .v-input__prepend > .v-icon,
:where(.vuetify-styles) .v-input--disabled .v-input__prepend .v-messages,
:where(.vuetify-styles) .v-input--error .v-input__prepend > .v-icon,
:where(.vuetify-styles) .v-input--error .v-input__prepend .v-messages,
:where(.vuetify-styles) .v-input--disabled .v-input__append > .v-icon,
:where(.vuetify-styles) .v-input--disabled .v-input__append .v-messages,
:where(.vuetify-styles) .v-input--error .v-input__append > .v-icon,
:where(.vuetify-styles) .v-input--error .v-input__append .v-messages {
  opacity: 1;
}
:where(.vuetify-styles) .v-input--glow.v-input--focused .v-input__details > .v-icon,
:where(.vuetify-styles) .v-input--glow.v-input--focused .v-input__prepend > .v-icon,
:where(.vuetify-styles) .v-input--glow.v-input--focused .v-input__append > .v-icon {
  opacity: 1;
}
:where(.vuetify-styles) .v-input--disabled .v-input__details,
:where(.vuetify-styles) .v-input--disabled .v-input__prepend,
:where(.vuetify-styles) .v-input--disabled .v-input__append {
  opacity: var(--v-disabled-opacity);
}
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__details > .v-icon,
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__details .v-messages,
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__prepend > .v-icon,
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__prepend .v-messages,
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__append > .v-icon,
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-input__append .v-messages {
  color: rgb(var(--v-theme-error));
}

:where(.vuetify-styles) .v-input__prepend,
:where(.vuetify-styles) .v-input__append {
  display: flex;
  align-items: flex-start;
  padding-top: var(--v-input-padding-top);
}
:where(.vuetify-styles) .v-input--center-affix .v-input__prepend,
:where(.vuetify-styles) .v-input--center-affix .v-input__append {
  align-items: center;
  padding-top: 0;
}

:where(.vuetify-styles) .v-input__prepend {
  grid-area: prepend;
}

:where(.vuetify-styles) .v-input__append {
  grid-area: append;
}

:where(.vuetify-styles) .v-input__control {
  display: flex;
  grid-area: control;
}

:where(.vuetify-styles) .v-input--hide-spin-buttons input::-webkit-outer-spin-button,
:where(.vuetify-styles) .v-input--hide-spin-buttons input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
:where(.vuetify-styles) .v-input--hide-spin-buttons input[type=number] {
  -moz-appearance: textfield;
}
:where(.vuetify-styles) .v-input--plain-underlined .v-input__prepend,
:where(.vuetify-styles) .v-input--plain-underlined .v-input__append {
  align-items: flex-start;
}
:where(.vuetify-styles) .v-input--density-default.v-input--plain-underlined .v-input__prepend, :where(.vuetify-styles) .v-input--density-default.v-input--plain-underlined .v-input__append {
  padding-top: calc(var(--v-input-padding-top) + 4px);
}

:where(.vuetify-styles) .v-input--density-comfortable.v-input--plain-underlined .v-input__prepend, :where(.vuetify-styles) .v-input--density-comfortable.v-input--plain-underlined .v-input__append {
  padding-top: calc(var(--v-input-padding-top) + 2px);
}

:where(.vuetify-styles) .v-input--density-compact.v-input--plain-underlined .v-input__prepend, :where(.vuetify-styles) .v-input--density-compact.v-input--plain-underlined .v-input__append {
  padding-top: calc(var(--v-input-padding-top) + 0px);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VInput/VInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,6DAA6D;EAC7D,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;;EAGE,yCAAyC;AAC3C;AACA;;;;;;;;;;;;EAWE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,kCAAkC;AACpC;AACA;;;;;;EAME,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,uCAAuC;AACzC;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD","sourcesContent":[".v-input {\n  display: grid;\n  flex: 1 1 auto;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n.v-input--disabled {\n  pointer-events: none;\n}\n.v-input--density-default {\n  --v-input-control-height: 56px;\n  --v-input-padding-top: 16px;\n}\n\n.v-input--density-comfortable {\n  --v-input-control-height: 48px;\n  --v-input-padding-top: 12px;\n}\n\n.v-input--density-compact {\n  --v-input-control-height: 40px;\n  --v-input-padding-top: 8px;\n}\n\n.v-input--vertical {\n  grid-template-areas: \"append\" \"control\" \"prepend\";\n  grid-template-rows: max-content auto max-content;\n  grid-template-columns: min-content;\n}\n.v-input--vertical .v-input__prepend {\n  margin-block-start: 16px;\n}\n.v-input--vertical .v-input__append {\n  margin-block-end: 16px;\n}\n\n.v-input--horizontal {\n  grid-template-areas: \"prepend control append\" \"a messages b\";\n  grid-template-columns: max-content minmax(0, 1fr) max-content;\n  grid-template-rows: 1fr auto;\n}\n.v-input--horizontal .v-input__prepend {\n  margin-inline-end: 16px;\n}\n.v-input--horizontal .v-input__append {\n  margin-inline-start: 16px;\n}\n\n.v-input__details {\n  align-items: flex-end;\n  display: flex;\n  font-size: 0.75rem;\n  font-weight: 400;\n  grid-area: messages;\n  letter-spacing: 0.0333333333em;\n  line-height: normal;\n  min-height: 22px;\n  padding-top: 6px;\n  overflow: hidden;\n  justify-content: space-between;\n}\n\n.v-input__details > .v-icon,\n.v-input__prepend > .v-icon,\n.v-input__append > .v-icon {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-input--disabled .v-input__details > .v-icon,\n.v-input--disabled .v-input__details .v-messages, .v-input--error .v-input__details > .v-icon,\n.v-input--error .v-input__details .v-messages,\n.v-input--disabled .v-input__prepend > .v-icon,\n.v-input--disabled .v-input__prepend .v-messages,\n.v-input--error .v-input__prepend > .v-icon,\n.v-input--error .v-input__prepend .v-messages,\n.v-input--disabled .v-input__append > .v-icon,\n.v-input--disabled .v-input__append .v-messages,\n.v-input--error .v-input__append > .v-icon,\n.v-input--error .v-input__append .v-messages {\n  opacity: 1;\n}\n.v-input--glow.v-input--focused .v-input__details > .v-icon,\n.v-input--glow.v-input--focused .v-input__prepend > .v-icon,\n.v-input--glow.v-input--focused .v-input__append > .v-icon {\n  opacity: 1;\n}\n.v-input--disabled .v-input__details,\n.v-input--disabled .v-input__prepend,\n.v-input--disabled .v-input__append {\n  opacity: var(--v-disabled-opacity);\n}\n.v-input--error:not(.v-input--disabled) .v-input__details > .v-icon,\n.v-input--error:not(.v-input--disabled) .v-input__details .v-messages,\n.v-input--error:not(.v-input--disabled) .v-input__prepend > .v-icon,\n.v-input--error:not(.v-input--disabled) .v-input__prepend .v-messages,\n.v-input--error:not(.v-input--disabled) .v-input__append > .v-icon,\n.v-input--error:not(.v-input--disabled) .v-input__append .v-messages {\n  color: rgb(var(--v-theme-error));\n}\n\n.v-input__prepend,\n.v-input__append {\n  display: flex;\n  align-items: flex-start;\n  padding-top: var(--v-input-padding-top);\n}\n.v-input--center-affix .v-input__prepend,\n.v-input--center-affix .v-input__append {\n  align-items: center;\n  padding-top: 0;\n}\n\n.v-input__prepend {\n  grid-area: prepend;\n}\n\n.v-input__append {\n  grid-area: append;\n}\n\n.v-input__control {\n  display: flex;\n  grid-area: control;\n}\n\n.v-input--hide-spin-buttons input::-webkit-outer-spin-button,\n.v-input--hide-spin-buttons input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.v-input--hide-spin-buttons input[type=number] {\n  -moz-appearance: textfield;\n}\n.v-input--plain-underlined .v-input__prepend,\n.v-input--plain-underlined .v-input__append {\n  align-items: flex-start;\n}\n.v-input--density-default.v-input--plain-underlined .v-input__prepend, .v-input--density-default.v-input--plain-underlined .v-input__append {\n  padding-top: calc(var(--v-input-padding-top) + 4px);\n}\n\n.v-input--density-comfortable.v-input--plain-underlined .v-input__prepend, .v-input--density-comfortable.v-input--plain-underlined .v-input__append {\n  padding-top: calc(var(--v-input-padding-top) + 2px);\n}\n\n.v-input--density-compact.v-input--plain-underlined .v-input__prepend, .v-input--density-compact.v-input--plain-underlined .v-input__append {\n  padding-top: calc(var(--v-input-padding-top) + 0px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
